export const FETCH_CONFIGURATIONS_SUCCESS = 'FETCH_CONFIGURATIONS_SUCCESS'
export const FETCH_CONFIGURATIONS_FAILURE = 'FETCH_CONFIGURATIONS_FAILURE'
export const FETCH_CONFIGURATION_SUCCESS = 'FETCH_CONFIGURATION_SUCCESS'
export const FETCH_CONFIGURATION_FAILURE = 'FETCH_CONFIGURATION_FAILURE'
export const UPDATE_CONFIGURATION_SUCCESS = 'UPDATE_CONFIGURATION_SUCCESS'
export const CREATE_CONFIGURATION_SUCCESS = 'CREATE_CONFIGURATION_SUCCESS'
export const FETCH_PRESIGNED_S3_URL_SUCCESS = 'FETCH_PRESIGNED_S3_URL_SUCCESS'
export const DELETE_CONFIGURATION_SUCCESS = 'DELETE_CONFIGURATION_SUCCESS'

import { request } from '../helpers/apiHelper'
import { displayNotification } from './notificationsActions'

export const fetchConfigurations = () => (dispatch) => {
  return request(
    `query {
      configurations {
        androidCprEnabled
        androidUpgradeReason
        appStoreId
        appStoreUrl
        askingPricePercentOver
        askingPricePercentUnder
        askingPriceStep
        callCenterLink
        callCenterLogoPath
        callCenterName
        createdAt
        downPaymentPercentDefault
        downPaymentPercentMin
        downPaymentStep
        estimatedPaymentDownPct
        estimatedPaymentTerm
        estimatedPaymentTier
        faqUrl
        feedbackEmail
        id
        infoEmail
        iosUpgradeReason
        maxMinAmountFinanced
        maxMonthlyPayment
        maxTerm
        maxVehicleAge
        maxVehicleMileage
        minAndroidApp
        minIosApp
        minIosOs
        minMonthlyPayment
        minTerm
        monthlyPaymentStep
        offerAmountAdditionalPercentOver
        offerAmountAdditionalPercentUnder
        offerAmountStep
        defaultOwnerId
        ensuretyAccountCode
        paymentFlow
        periodsPerYear
        profitDiscountMax
        validationDiscountMax
        profitDiscountPercent
        profitMarkupDefault
        refiCashBackStep
        refiMinCashBack
        refiMinPmtDiff
        signaturePath
        supportEmail
        supportHoursText
        supportPhone
        testMode
        homeProtectionHandoff
        homeProtectionHandoffApiKeyConfigured
        blinker2OrgCode
        firstPaymentMinDays
        firstPaymentMaxDays
        timezone
        availableTimezones
        updatedAt
        versions{
           id
           event
           whodunnit
           ipAddress
           source
           createdAt
           objectChanges
        }
        organization {
          id
        }
      }
    }`,
    {},
    '/admin/graphql'
  ).then((response) => {
    dispatch({
      type: FETCH_CONFIGURATIONS_SUCCESS,
      entities: response.data.data.configurations,
    })
  })
}

export const fetchConfiguration = (configurationId) => (dispatch) => {
  return request(
    `query {
      configuration(id: ${configurationId}) {
        androidCprEnabled
        androidUpgradeReason
        appStoreId
        appStoreUrl
        askingPricePercentOver
        askingPricePercentUnder
        askingPriceStep
        callCenterLink
        callCenterLogoPath
        callCenterName
        createdAt
        downPaymentPercentDefault
        downPaymentPercentMin
        downPaymentStep
        estimatedPaymentDownPct
        estimatedPaymentTerm
        estimatedPaymentTier
        faqUrl
        feedbackEmail
        id
        infoEmail
        iosUpgradeReason
        maxMinAmountFinanced
        maxMonthlyPayment
        maxTerm
        maxVehicleAge
        maxVehicleMileage
        minAndroidApp
        minIosApp
        minIosOs
        minMonthlyPayment
        minTerm
        monthlyPaymentStep
        offerAmountAdditionalPercentOver
        offerAmountAdditionalPercentUnder
        offerAmountStep
        defaultOwnerId
        ensuretyAccountCode
        paymentFlow
        periodsPerYear
        profitDiscountMax
        validationDiscountMax
        profitDiscountPercent
        profitMarkupDefault
        refiCashBackStep
        refiMinCashBack
        refiMinPmtDiff
        signaturePath
        supportEmail
        supportHoursText
        supportPhone
        testMode
        homeProtectionHandoff
        homeProtectionHandoffApiKeyConfigured
        blinker2OrgCode
        firstPaymentMinDays
        firstPaymentMaxDays
        updatedAt
        timezone
        availableTimezones
        versions{
           id
           event
           whodunnit
           ipAddress
           source
           createdAt
           objectChanges
        }
        organization {
          id
        }
      }
    }`,
    {},
    '/admin/graphql'
  )
    .then((response) => {
      const { configuration } = response.data.data

      dispatch({
        type: FETCH_CONFIGURATION_SUCCESS,
        entity: configuration,
      })

      return Promise.resolve(configuration)
    })
    .catch(() => {
      dispatch({
        type: FETCH_CONFIGURATION_FAILURE,
      })
      dispatch(
        displayNotification('Failed to fetch CONFIGURATIONS', 'error', 10000)
      )
    })
}

export const createConfiguration = (values) => (dispatch) => {
  const {
    androidCprEnabled,
    androidUpgradeReason,
    appStoreId,
    appStoreUrl,
    askingPricePercentOver,
    askingPricePercentUnder,
    askingPriceStep,
    callCenterLink,
    callCenterName,
    defaultOwnerId,
    downPaymentPercentDefault,
    downPaymentPercentMin,
    downPaymentStep,
    estimatedPaymentDownPct,
    estimatedPaymentTerm,
    estimatedPaymentTier,
    faqUrl,
    feedbackEmail,
    infoEmail,
    iosUpgradeReason,
    maxMinAmountFinanced,
    maxMonthlyPayment,
    maxTerm,
    maxVehicleAge,
    maxVehicleMileage,
    minAndroidApp,
    minIosApp,
    minIosOs,
    minMonthlyPayment,
    minTerm,
    monthlyPaymentStep,
    offerAmountAdditionalPercentOver,
    offerAmountAdditionalPercentUnder,
    offerAmountStep,
    periodsPerYear,
    profitDiscountMax,
    validationDiscountMax,
    profitDiscountPercent,
    profitMarkupDefault,
    refiCashBackStep,
    refiMinCashBack,
    refiMinPmtDiff,
    supportEmail,
    supportHoursText,
    supportPhone,
    testMode,
    homeProtectionHandoff,
    homeProtectionHandoffApiKey,
    blinker2OrgCode,
    firstPaymentMinDays,
    firstPaymentMaxDays,
    ensuretyAccountCode,
    paymentFlow,
    timezone
  } = values
  return request(
    `mutation CreateConfiguration($input: CreateConfigurationInput!) {
      createConfiguration(input: $input) {
        configuration {
          androidCprEnabled
          androidUpgradeReason
          appStoreId
          appStoreUrl
          askingPricePercentOver
          askingPricePercentUnder
          askingPriceStep
          callCenterLink
          callCenterLogoPath
          callCenterName
          createdAt
          downPaymentPercentDefault
          downPaymentPercentMin
          downPaymentStep
          estimatedPaymentDownPct
          estimatedPaymentTerm
          estimatedPaymentTier
          faqUrl
          feedbackEmail
          id
          infoEmail
          iosUpgradeReason
          maxMinAmountFinanced
          maxMonthlyPayment
          maxTerm
          maxVehicleAge
          maxVehicleMileage
          minAndroidApp
          minIosApp
          minIosOs
          minMonthlyPayment
          minTerm
          monthlyPaymentStep
          offerAmountAdditionalPercentOver
          offerAmountAdditionalPercentUnder
          offerAmountStep
          ensuretyAccountCode
          paymentFlow
          periodsPerYear
          profitDiscountMax
          validationDiscountMax
          profitDiscountPercent
          profitMarkupDefault
          refiCashBackStep
          refiMinCashBack
          refiMinPmtDiff
          supportEmail
          supportHoursText
          supportPhone
          testMode
          homeProtectionHandoff
          homeProtectionHandoffApiKeyConfigured
          blinker2OrgCode
          updatedAt
          timezone
          firstPaymentMinDays
          firstPaymentMaxDays
        }
      }
    }`,
    {
      input: {
        androidCprEnabled,
        androidUpgradeReason,
        appStoreId,
        appStoreUrl,
        askingPricePercentOver: parseInt(askingPricePercentOver, 10),
        askingPricePercentUnder: parseInt(askingPricePercentUnder, 10),
        askingPriceStep,
        callCenterLink,
        ensuretyAccountCode,
        paymentFlow,
        callCenterName,
        downPaymentPercentDefault: parseInt(downPaymentPercentDefault, 10),
        downPaymentPercentMin: parseInt(downPaymentPercentMin, 10),
        downPaymentStep,
        estimatedPaymentDownPct: parseInt(estimatedPaymentDownPct, 10),
        estimatedPaymentTerm: parseInt(estimatedPaymentTerm, 10),
        estimatedPaymentTier: parseInt(estimatedPaymentTier, 10),
        faqUrl,
        feedbackEmail,
        infoEmail,
        iosUpgradeReason,
        maxMinAmountFinanced,
        maxMonthlyPayment,
        maxTerm: parseInt(maxTerm, 10),
        maxVehicleAge: parseInt(maxVehicleAge, 10),
        maxVehicleMileage: parseInt(maxVehicleMileage, 10),
        minAndroidApp,
        minIosApp,
        minIosOs,
        minMonthlyPayment,
        minTerm: parseInt(minTerm, 10),
        monthlyPaymentStep,
        offerAmountAdditionalPercentOver: parseInt(
          offerAmountAdditionalPercentOver,
          10
        ),
        offerAmountAdditionalPercentUnder: parseInt(
          offerAmountAdditionalPercentUnder,
          10
        ),
        offerAmountStep,
        periodsPerYear: parseInt(periodsPerYear, 10),
        profitDiscountMax,
        validationDiscountMax: parseFloat(validationDiscountMax),
        profitDiscountPercent: parseInt(profitDiscountPercent, 10),
        profitMarkupDefault,
        defaultOwnerId: defaultOwnerId ? parseInt(defaultOwnerId, 10) : null,
        refiCashBackStep,
        refiMinCashBack,
        refiMinPmtDiff,
        supportEmail,
        supportHoursText,
        supportPhone,
        testMode,
        homeProtectionHandoff,
        ...homeProtectionHandoffApiKeyInput(homeProtectionHandoffApiKey),
        blinker2OrgCode,
        firstPaymentMinDays: firstPaymentMinDays ? Number(firstPaymentMinDays) : 31,
        firstPaymentMaxDays: firstPaymentMaxDays ? Number(firstPaymentMaxDays) : 45,
        timezone
      },
    },
    '/admin/graphql'
  )
    .then((response) => {
      const { createConfiguration } = response.data.data

      // Check if createConfiguration is null, which indicates a GraphQL error
      if (
        !createConfiguration &&
        response.data.errors &&
        response.data.errors.length > 0
      ) {
        const errorMessage = response.data.errors
          .map((err) => err.message)
          .join(', ')
        dispatch(displayNotification(errorMessage, 'error', 10000))
        return Promise.reject(new Error(errorMessage)) // Stop further processing in this chain
      } else if (!createConfiguration) {
        // Fallback for unexpected null createConfiguration without explicit GraphQL errors
        dispatch(
          displayNotification(
            'Failed to create Configuration: Unexpected empty response',
            'error',
            10000
          )
        )
        return Promise.reject(new Error('Unexpected empty response'))
      }

      const { configuration } = createConfiguration
      dispatch({
        type: CREATE_CONFIGURATION_SUCCESS,
        entity: configuration,
      })

      return Promise.resolve(configuration)
    })
    .catch((error) => {
      let errorMessage = 'Failed to create Configuration'
      if (
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors.length > 0
      ) {
        errorMessage = error.response.data.errors[0].message
      }
      dispatch(displayNotification(errorMessage, 'error', 10000))
    })
}

export const deleteConfiguration = (id) => (dispatch) => {
  return request(
    `mutation DeleteConfiguration($input: DeleteConfigurationInput!) {
      deleteConfiguration(input: $input) {
        id
      }
    }`,
    { input: { id } },
    '/admin/graphql'
  )
    .then((response) => {
      if (response.data.errors) {
        const errorMessage = response.data.errors
          .map((err) => err.message)
          .join(', ')
        dispatch(displayNotification(errorMessage, 'error', 10000))
        return Promise.reject(new Error(errorMessage))
      }
      dispatch({
        type: DELETE_CONFIGURATION_SUCCESS,
        id,
      })
      dispatch(
        displayNotification('Configuration deleted successfully', 'success')
      )
      // history.push('/configuration'); // Moved to component for conditional redirect
      return Promise.resolve(response)
    })
    .catch((error) => {
      let errorMessage = 'Failed to delete Configuration'
      if (
        error.response &&
        error.response.data &&
        error.response.data.errors &&
        error.response.data.errors.length > 0
      ) {
        errorMessage = error.response.data.errors
          .map((err) => err.message)
          .join(', ')
      }
      dispatch(displayNotification(errorMessage, 'error', 10000))
      return Promise.reject(error)
    })
}

export const homeProtectionHandoffApiKeyInput = (apiKey, clear = false) => {
  if (typeof apiKey === 'string' && apiKey.trim()) {
    return { homeProtectionHandoffApiKey: apiKey.trim() }
  }
  if (clear) return { homeProtectionHandoffApiKey: '' }

  return {}
}

export const updateConfiguration = (id, values) => (dispatch) => {
  const {
    androidCprEnabled,
    androidUpgradeReason,
    appStoreId,
    appStoreUrl,
    askingPricePercentOver,
    askingPricePercentUnder,
    askingPriceStep,
    callCenterLink,
    callCenterLogoPath,
    callCenterName,
    defaultOwnerId,
    downPaymentPercentDefault,
    downPaymentPercentMin,
    downPaymentStep,
    estimatedPaymentDownPct,
    estimatedPaymentTerm,
    estimatedPaymentTier,
    faqUrl,
    feedbackEmail,
    infoEmail,
    iosUpgradeReason,
    maxMinAmountFinanced,
    maxMonthlyPayment,
    maxTerm,
    maxVehicleAge,
    maxVehicleMileage,
    minAndroidApp,
    minIosApp,
    minIosOs,
    minMonthlyPayment,
    minTerm,
    monthlyPaymentStep,
    offerAmountAdditionalPercentOver,
    offerAmountAdditionalPercentUnder,
    offerAmountStep,
    periodsPerYear,
    profitDiscountMax,
    validationDiscountMax,
    profitDiscountPercent,
    profitMarkupDefault,
    refiCashBackStep,
    refiMinCashBack,
    refiMinPmtDiff,
    supportEmail,
    supportHoursText,
    supportPhone,
    testMode,
    homeProtectionHandoff,
    homeProtectionHandoffApiKey,
    clearHomeProtectionHandoffApiKey,
    blinker2OrgCode,
    firstPaymentMinDays,
    firstPaymentMaxDays,
    ensuretyAccountCode,
    paymentFlow,
    timezone
  } = values
  return request(
    `mutation UpdateConfiguration($id: ID!, $periodsPerYear: Int, $minMonthlyPayment: String, $offerAmountStep: String, $offerAmountAdditionalPercentUnder: Int, $offerAmountAdditionalPercentOver: Int, $monthlyPaymentStep: String, $askingPriceStep: String, $askingPricePercentUnder: Int, $askingPricePercentOver: Int, $estimatedPaymentTier: Int, $estimatedPaymentDownPct: Int, $downPaymentPercentDefault: Int, $downPaymentPercentMin: Int, $downPaymentStep: String, $estimatedPaymentTerm: Int, $minTerm: Int, $maxVehicleAge: Int, $maxVehicleMileage: Int, $maxMinAmountFinanced: String, $faqUrl: String, $feedbackEmail: String, $infoEmail: String, $supportEmail: String, $supportPhone: String, $maxMonthlyPayment: String, $maxTerm: Int, $minAndroidApp: String, $minIosApp: String,  $minIosOs: String, $appStoreId: String, $appStoreUrl: String, $androidUpgradeReason: String, $iosUpgradeReason: String, $refiCashBackStep: String, $refiMinCashBack: String, $refiMinPmtDiff: String, $supportHoursText: String, $androidCprEnabled: Boolean, $profitMarkupDefault: String, $profitDiscountMax: String, $validationDiscountMax: Float, $profitDiscountPercent: Int, $defaultOwnerId: Int, $callCenterName: String, $callCenterLogoPath: String, $ensuretyAccountCode: String, $paymentFlow: String, $callCenterLink: String, $testMode: Boolean, $homeProtectionHandoff: Boolean, $homeProtectionHandoffApiKey: String, $blinker2OrgCode: String, $firstPaymentMinDays: Int, $firstPaymentMaxDays: Int, $timezone: String) {
      updateConfiguration(id: $id, periodsPerYear: $periodsPerYear, minMonthlyPayment: $minMonthlyPayment, offerAmountStep: $offerAmountStep, offerAmountAdditionalPercentUnder: $offerAmountAdditionalPercentUnder, offerAmountAdditionalPercentOver: $offerAmountAdditionalPercentOver, monthlyPaymentStep: $monthlyPaymentStep, askingPriceStep: $askingPriceStep, askingPricePercentUnder: $askingPricePercentUnder, askingPricePercentOver: $askingPricePercentOver, estimatedPaymentTier: $estimatedPaymentTier, estimatedPaymentDownPct: $estimatedPaymentDownPct, downPaymentPercentDefault: $downPaymentPercentDefault, downPaymentPercentMin: $downPaymentPercentMin, downPaymentStep: $downPaymentStep, estimatedPaymentTerm: $estimatedPaymentTerm, minTerm: $minTerm, maxVehicleAge: $maxVehicleAge, maxVehicleMileage: $maxVehicleMileage, maxMinAmountFinanced: $maxMinAmountFinanced, faqUrl: $faqUrl, feedbackEmail: $feedbackEmail, infoEmail: $infoEmail, supportEmail: $supportEmail, supportPhone: $supportPhone, maxMonthlyPayment: $maxMonthlyPayment, maxTerm: $maxTerm, minAndroidApp: $minAndroidApp, minIosApp: $minIosApp, minIosOs: $minIosOs, appStoreId: $appStoreId, appStoreUrl: $appStoreUrl, androidUpgradeReason: $androidUpgradeReason, iosUpgradeReason: $iosUpgradeReason, refiCashBackStep: $refiCashBackStep, refiMinCashBack: $refiMinCashBack, refiMinPmtDiff: $refiMinPmtDiff, supportHoursText: $supportHoursText, androidCprEnabled: $androidCprEnabled, profitMarkupDefault: $profitMarkupDefault, profitDiscountMax: $profitDiscountMax, defaultOwnerId: $defaultOwnerId, validationDiscountMax: $validationDiscountMax, profitDiscountPercent: $profitDiscountPercent, callCenterName: $callCenterName, callCenterLogoPath: $callCenterLogoPath, ensuretyAccountCode: $ensuretyAccountCode, paymentFlow: $paymentFlow, callCenterLink: $callCenterLink, testMode: $testMode, homeProtectionHandoff: $homeProtectionHandoff, homeProtectionHandoffApiKey: $homeProtectionHandoffApiKey, blinker2OrgCode: $blinker2OrgCode, firstPaymentMinDays: $firstPaymentMinDays, firstPaymentMaxDays: $firstPaymentMaxDays, timezone: $timezone) {
        androidCprEnabled
        androidUpgradeReason
        appStoreId
        appStoreUrl
        askingPricePercentOver
        askingPricePercentUnder
        askingPriceStep
        callCenterLink
        callCenterLogoPath
        callCenterName
        createdAt
        downPaymentPercentDefault
        downPaymentPercentMin
        downPaymentStep
        estimatedPaymentDownPct
        estimatedPaymentTerm
        estimatedPaymentTier
        faqUrl
        feedbackEmail
        id
        infoEmail
        iosUpgradeReason
        maxMinAmountFinanced
        maxMonthlyPayment
        maxTerm
        maxVehicleAge
        maxVehicleMileage
        minAndroidApp
        minIosApp
        minIosOs
        minMonthlyPayment
        minTerm
        monthlyPaymentStep
        offerAmountAdditionalPercentOver
        offerAmountAdditionalPercentUnder
        offerAmountStep
        defaultOwnerId
        ensuretyAccountCode
        paymentFlow
        periodsPerYear
        profitDiscountMax
        validationDiscountMax
        profitDiscountPercent
        profitMarkupDefault
        refiCashBackStep
        refiMinCashBack
        refiMinPmtDiff
        supportEmail
        supportHoursText
        supportPhone
        testMode
        homeProtectionHandoff
        homeProtectionHandoffApiKeyConfigured
        blinker2OrgCode
        firstPaymentMinDays
        firstPaymentMaxDays
        updatedAt
        timezone
      }
    }`,
    {
      androidCprEnabled,
      androidUpgradeReason,
      appStoreId,
      appStoreUrl,
      askingPricePercentOver: parseInt(askingPricePercentOver, 10),
      askingPricePercentUnder: parseInt(askingPricePercentUnder, 10),
      askingPriceStep,
      callCenterLink,
      callCenterLogoPath,
      callCenterName,
      ensuretyAccountCode,
      paymentFlow,
      downPaymentPercentDefault: parseInt(downPaymentPercentDefault, 10),
      downPaymentPercentMin: parseInt(downPaymentPercentMin, 10),
      downPaymentStep,
      estimatedPaymentDownPct: parseInt(estimatedPaymentDownPct, 10),
      estimatedPaymentTerm: parseInt(estimatedPaymentTerm, 10),
      estimatedPaymentTier: parseInt(estimatedPaymentTier, 10),
      faqUrl,
      feedbackEmail,
      id,
      infoEmail,
      iosUpgradeReason,
      maxMinAmountFinanced,
      maxMonthlyPayment,
      maxTerm: parseInt(maxTerm, 10),
      maxVehicleAge: parseInt(maxVehicleAge, 10),
      maxVehicleMileage: parseInt(maxVehicleMileage, 10),
      minAndroidApp,
      minIosApp,
      minIosOs,
      minMonthlyPayment,
      minTerm: parseInt(minTerm, 10),
      monthlyPaymentStep,
      offerAmountAdditionalPercentOver: parseInt(
        offerAmountAdditionalPercentOver,
        10
      ),
      offerAmountAdditionalPercentUnder: parseInt(
        offerAmountAdditionalPercentUnder,
        10
      ),
      offerAmountStep,
      periodsPerYear: parseInt(periodsPerYear, 10),
      profitDiscountMax,
      validationDiscountMax: parseFloat(validationDiscountMax),
      profitDiscountPercent: parseInt(profitDiscountPercent, 10),
      profitMarkupDefault,
      refiCashBackStep,
      refiMinCashBack,
      refiMinPmtDiff,
      supportEmail,
      supportHoursText,
      supportPhone,
      testMode,
      homeProtectionHandoff,
      ...homeProtectionHandoffApiKeyInput(
        homeProtectionHandoffApiKey,
        clearHomeProtectionHandoffApiKey
      ),
      blinker2OrgCode,
      defaultOwnerId: defaultOwnerId ? parseInt(defaultOwnerId, 10) : null,
      firstPaymentMinDays: firstPaymentMinDays ? Number(firstPaymentMinDays) : 31,
      firstPaymentMaxDays: firstPaymentMaxDays ? Number(firstPaymentMaxDays) : 45,
      timezone,
    },
    '/admin/graphql'
  )
    .then((response) => {
      const { updateConfiguration } = response.data.data
      dispatch({
        type: UPDATE_CONFIGURATION_SUCCESS,
        entity: updateConfiguration,
      })

      return Promise.resolve(updateConfiguration)
    })
    .catch(() => {
      dispatch(
        displayNotification('Failed to update Configuration', 'error', 10000)
      )
    })
}

export const fetchPresignedS3Url =
  (filename: string, contentType: string, contentMD5: string) => (dispatch) => {
    return request(
      null,
      null,
      `/api/v3/configurations/presign_s3?filename=${filename}&content_type=${contentType}&content_md5=${contentMD5}`,
      'POST'
    )
      .then((response) => {
        dispatch({
          type: FETCH_PRESIGNED_S3_URL_SUCCESS,
          payload: response.data,
        })
        return Promise.resolve(response.data)
      })
      .catch((error) => {
        dispatch(
          displayNotification('Failed to get pre-signed S3 URL', 'error', 10000)
        )
        return Promise.reject(error)
      })
  }

export const fetchPresignedS3UrlForGet = (key: string): Promise<string> => {
  return request(
    null,
    null,
    `/api/v3/configurations/presigned_url?key=${key}`,
    'GET'
  )
    .then((response) => {
      return Promise.resolve(response.data.url)
    })
    .catch((error) => {
      return Promise.reject(error)
    })
}
